import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
class MainLinkBadge extends Component {
	render() {
		const { label } = this.props;
		return <div className="main-link-badge">{label}</div>;
	}
}
MainLinkBadge.propTypes = {
	label: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default MainLinkBadge;
